// Dependencies
import _ from 'lodash'

export const // https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
  isObject = (item: any) => {
    return item && typeof item === 'object' && !Array.isArray(item)
  },
  // https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
  mergeDeep = (target: any, ...sources: any): any => {
    if (!sources.length) return target
    const source = sources.shift()

    if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} })
          mergeDeep(target[key], source[key])
        } else {
          Object.assign(target, { [key]: source[key] })
        }
      }
    }

    return mergeDeep(target, ...sources)
  },
  /**
   *
   * @param value Any data type can be argued
   * @returns changed string if is string and contains an alpha channel, otherwise original value
   */
  excludeAlpha = (value: any) => {
    if (typeof value === 'string' && value.substring(0, 4) === 'rgba') {
      value = value.replace(/[^,]+(?=\))/, '1')
    }
    return value
  },
  clamp = (
    prop: string,
    min: number,
    max: number,
    base: number | undefined = 5,
  ) => `
  ${prop}: ${(min + max) / 2}em;
  @supports(${prop}: clamp( ${min}em, ${base}vw, ${max}em) ) {
    ${prop}: clamp(${min}em, ${base}vw, ${max}em);
  }
`
